<template>
    <Error500View v-if="has500" />
    <Error404View v-else-if="has404" />
    <RouterView v-else />
</template>

<script lang="ts" setup>
import Error404View from '@/views/Error404View.vue';
import Error500View from '@/views/Error500View.vue';

import { computed } from 'vue';
import { useError } from '@/composables/error';
import { useFavicon, useTitle } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { useTheme } from '@/composables/theme';

import client from '@/api/client';

const { favicon, siteName } = useTheme()
const { has500, has404 } = useError()

const { t } = useI18n();
const { locale } = useI18n<string>({ useScope: 'global' });

const title = computed(() => `${t('common.title')} ${siteName.value}`)

useTitle(title)
useFavicon(favicon)

client.interceptors.request.use(function (config) {
    config.headers.set('System-Language', locale.value.replace('_', '-'))

    return config;
}, function (error) {
    return error;
});
</script>
